import React from 'react'
import styled from '@emotion/styled'
import { ProfileCard } from '@core/Areas/FollowMe/Components/Common/ProfileCard'
import type { FollowMeProfile } from '@core/Areas/FollowMe/types'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'
import { SvgLazy } from '@mobi/component-library/Common/Svg/SvgLazy'
import { Constants } from '@mobi/settings/constants'

const enum LocalConstants {
  CardWidth = '32rem',
}

export const ShareProfileContent = React.forwardRef<HTMLDivElement, { profile: FollowMeProfile }>(
  ({ profile }, ref) => (
    <WrapperStyled>
      <div ref={ref}>
        <div>
          <ProfileCard profile={profile} />
        </div>

        <div className='share-profile__branding'>
          <div>
            <SvgLazy name='TABtouchLogo' width='12rem' color={colors.studio[600]} />
            <SvgLazy name='BetLoopHeaderLogo' width='7rem' color={colors.studio[600]} />
          </div>

          <p>Gamble responsibly. Call Gambling Help on {Constants.GamblingHelpPhoneNumber}</p>
        </div>
      </div>
    </WrapperStyled>
  )
)

ShareProfileContent.displayName = 'ShareProfileContent'

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  position: 'absolute',
  left: -999999,
  width: `calc(${LocalConstants.CardWidth} + ${spacing.lgx2} * 2)`,

  '> div': {
    position: 'relative',
    padding: `${spacing.bigx2} ${spacing.lgx2}`,
    paddingBottom: 0,
    background: colors.white,
    backgroundImage: `repeating-conic-gradient(from 45deg at 50% 90%, ${colors.studio[600]} 0deg 5deg, white 4deg 9deg)`,

    '::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: 'rgba(255,255,255,0.98)',
    },

    // Card Display
    '> div:first-of-type': {
      position: 'relative',
      zIndex: 1,
      maxWidth: '32rem',
      filter:
        'drop-shadow(0 10rem 4rem rgba(104,56,140,0.01)) drop-shadow(0 6rem 3.5rem rgba(104,56,140,0.05)) drop-shadow(0 2.6rem 2.6rem rgba(104,56,140,0.09)) drop-shadow(0 0.7rem 1.4rem rgba(104,56,140,0.10))',
    },

    '.share-profile__branding': {
      position: 'relative',
      zIndex: 2,
      background: 'radial-gradient(white, transparent)',
      paddingBottom: spacing.md,

      '> div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: spacing.md,
        paddingTop: spacing.big,
      },

      p: {
        paddingTop: spacing.sm,
        margin: 0,
        fontFamily: font.family.primary,
        fontSize: font.size.xs.fontSize,
        lineHeight: font.size.xs.lineHeight,
        textAlign: 'center',
        color: 'rgba(0,0,0,0.53)',
      },
    },
  },
})
